import type { Theme } from "@mui/material/styles";

const menuDimensionTokens = {
    listMinWidth: "180px",
    borderWidth: "1px",
} as const;

export const getMenuTokens = (theme: Theme) => ({
    list: {
        backgroundColor: "white",
        boxShadow: "none",
        color: "inherit",
        minWidth: menuDimensionTokens.listMinWidth,
        paddingTop: 0,
        paddingBottom: 0,
        zIndex: 1,
        borderRadius: theme.shape.borderRadius,
        borderWidth: menuDimensionTokens.borderWidth,
        borderStyle: "solid",
        borderColor: "var(--mui-palette-gray-200)",
        marginTop: 0,
    },
    item: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: theme.spacing(6),
        fontSize: theme.typography.md,
        transitionProperty: "background",
        transitionDuration: "0.1s",
        transitionTimingFunction: "ease-in",
        focusBackgroundColor: "var(--mui-palette-gray-100)",
        activeBackgroundColor: "var(--mui-palette-gray-200)",
        expandedBackgroundColor: "var(--mui-palette-gray-100)",
        disabledOpacity: 0.4,
        disabledCursor: "not-allowed",
    },
    groupTitle: {
        marginInline: theme.spacing(2),
        marginBlock: theme.spacing(1),
        fontWeight: theme.typography.fontWeightSemibold,
        fontSize: theme.typography.sm,
    },
    divider: {
        border: 0,
        borderBottom: `${menuDimensionTokens.borderWidth} solid`,
        borderColor: "inherit",
        marginBlock: theme.spacing(1),
        opacity: 0.6,
    },
});

export const getMenuVariants = (theme: Theme) => ({
    contextMenu: {
        list: {
            minWidth: "unset",
            marginTop: theme.spacing(1),
        },
    },
});
